// Delete Product from List By Id
export const deleteProduct = (list, id) => {
  const filter = list.filter((item) => item.id !== id);
  return filter;
};

export const deleteProductByCode = (list, pcode) => {
  const filter = list.filter((item) => item.pcode !== pcode);
  return filter;
};

// Find Product Index From List
export const findProductIndex = (list, slug) => {
  const index = list.findIndex((item) => item.slug === slug);
  return index;
};
export const findProductIndexById = (list, id) => {
  const index = list.findIndex((item) => item.id === id);
  return index;
};
export const findProductIndexByCode = (list, pcode) => {
  const index = list?.findIndex((item) => item.pcode === pcode);
  return index;
};
